import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup, Row} from "react-bootstrap";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopAlertOstrzezenie, TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import CennikBiletowService from "../../CennikBiletowService";
import ZnizkiService from "../../../znizki/ZnizkiService";


export default class CenyBiletowSelectFrom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            znizki: [],
            znizka: null,
            error: false,
            daty: [],
            dataDo: null,
            brakDat: false
        };
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeZnizka = this.onChangeZnizka.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onClickPokaz = this.onClickPokaz.bind(this);

    }

    componentDidMount() {
        this.ustawDaneWyszukaniaCennikaZKonfiguracji(this.props)
    }

    componentWillReceiveProps(nextprops) {
        //  this.ustawDaneWyszukaniaCennikaZKonfiguracji(nextprops)
        if(nextprops.wyczyscFormularzSzukania){
            this.setState({
                trasa: null,
                znizki: [],
                znizka: null,
                error: false,
                daty: [],
                dataDo: null,
                brakDat: false})
            this.props.przerwijCzyszczenieSzukania()
        }
    }

    ustawDaneWyszukaniaCennikaZKonfiguracji(props) {

        if (Boolean(props.wyszukajCennik)) {
            let trasa = this.props.trasy.find(t => t.idTr === props.wyszukajCennik.id_tr)
            let znizka = this.props.znizki.find(z => z.rodz === props.wyszukajCennik.rodz)

            this.setState({
                trasa: trasa,
                znizka: znizka
            })

            if (Boolean(trasa) && Boolean(znizka)) {
                this.pobierzDatyCennika(trasa, znizka)
            }

        }
    }

    pobierzZnizki(trasa) {
        ZnizkiService.getZnizkiDanejTrasy(trasa.idTr).then(function (response) {
            if (response.status < 300) {
                if (response.data.length > 0) {
                    this.setState({znizki: response.data, znizka: response.data[0]})
                    this.pobierzDatyCennika(trasa, response.data[0])
                }
            }
        }.bind(this))
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr}
            <TopDostepnosc wartoscWarunek={0}
                           wartosc={option.status}
                           czyMarginesLewy={true}
            />
        </div>
    }

    formatZnizkaSelect(option) {
        return <div><span
            className={'label label-ebus-default'} style={{color:'#fff', background:option.kolor}}>{option.rodz}</span> {option.nazZniz} {Boolean(option.czyMies) ? '(miesięczny)' : ''}
            <div className={'pull-right'} style={{fontSize: '12px'}}>
                <span style={{marginRight: '5px'}}>
                    {Boolean(option.czyMies) ? '(M)' : '(J)'}
                </span>
                {
                    Boolean(option.esprzedaz) ?
                        <span title='Dostępny w esprzedaży' style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i> esprzedaż</span>
                        :
                        <span title='Zablokowany w esprzedaży' style={{color: 'firebrick'}}><i className={'fa fa-times'}></i> esprzedaż</span>
                }
            </div>
        </div>
    }

    onChangeTrasa(e) {
        this.props.ukryjCennik()
        this.setState({trasa: e, dataDo: null, brakDat: false, error: false, znizka: null, znizki: []})
        if (e !== null) {
            this.pobierzZnizki(e)
        }
    }

    onChangeZnizka(e) {
        this.props.ukryjCennik()
        this.setState({znizka: e, dataDo: null, brakDat: false, error: false})
        if (e !== null && Boolean(this.state.trasa)) {
            this.pobierzDatyCennika(this.state.trasa, e)
        }
    }

    onChangeDataDo(e) {
        this.props.ukryjCennik()
        this.props.dataSelect(e)
        this.setState({dataDo: e})
    }

    onClickPokaz() {
        this.setState({error: true})
        if (Boolean(this.state.trasa) && Boolean(this.state.znizka) && Boolean(this.state.dataDo)) {
            this.setState({error: false})
            this.props.handlePokaz(this.state.trasa, this.state.znizka, this.state.dataDo)
        }
    }

    pobierzDatyCennika(trasa, znizka) {
        CennikBiletowService.pobierzDatyCennikow(trasa.idTr, znizka.rodz).then(function (response) {
            if (response) {
                let arr = Array.from(response.data, item => {
                    this.props.dataSelect({data: item})
                    return {data: item}
                })
                if (arr.length <= 0) {
                    this.setState({brakDat: true})
                }else{
                    this.setState({daty: arr,dataDo:arr[arr.length-1]})
                }
            }
        }.bind(this))
    }

    render() {

        return (
            <Row>
                <Col xs={12}>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} md={4} lg={3}>
                                <ControlLabel>Trasa <span className={'req'}>*</span></ControlLabel>
                                <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy}
                                           valueKey={'idTr'} labelKey={'nazTr'}
                                           valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}
                                           placeholder={'Wybierz trasę...'} clearable={false}
                                />
                            </Col>
                            <Col xs={12} md={4} lg={3}>
                                <ControlLabel>Rodzaj cennika <span className={'req'}>*</span></ControlLabel>
                                <TopSelect onChange={this.onChangeZnizka} value={this.state.znizka} options={this.state.znizki}
                                           valueKey={'idZn'} labelKey={'rodz'}
                                           valueRenderer={this.formatZnizkaSelect} optionRenderer={this.formatZnizkaSelect}
                                           placeholder={'Wybierz cennik...'} disabled={!Boolean(this.state.trasa)}
                                           clearable={false}
                                />
                            </Col>
                            <Col xs={12} md={4} lg={2}>
                                <ControlLabel>Ważność od daty <span className={'req'}>*</span></ControlLabel>
                                <TopSelect placeholder={'Wybierz ważność od'}
                                           onChange={this.onChangeDataDo}
                                           value={this.state.dataDo}
                                           options={this.state.daty}
                                           labelKey={'data'}
                                           valueKey={'data'}
                                           disabled={(!Boolean(this.state.trasa) || !Boolean(this.state.znizka))}
                                           clearable={false}
                                />
                            </Col>
                            <Col xs={12} md={4} lg={4}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonAction text={'Pokaż cennik'} iconType={'fa fa-eye'} btnSize={'medium'} onClick={this.onClickPokaz}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <TopIf isTrue={this.state.error}>
                                    <TopAlertUwaga text={'Proszę uzupełnić pola'} inline={true}/>
                                </TopIf>
                                <TopIf isTrue={this.state.brakDat}>
                                    <TopAlertOstrzezenie text={'Brak dat. Proszę przejść do zakładki generuj'} inline={true}/>
                                </TopIf>
                            </Col>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/pokazCennik/components/CenyBiletowSelectFrom.js